import React from "react";
import { useNavigate } from "react-router-dom";
import { UiComponents } from "@simulanisindia/ui";
import { ChannelIcon, GroupTypesIcon, MyDashBoardIcon, MyDirectoryIcon } from "../assets/Icons";

const { Sidebar: UISidebar } = UiComponents;

const Sidebar = () => {
  const navigate = useNavigate();
  const menuItems = [
    {
      id: "0559daaf-1f73-410a-9d44-a33e0e1ecd",
      key: "dashboard/directories",
      tooltip: "Directories",
      icon: <MyDirectoryIcon />,
      clickHandler: () => navigate(`/dashboard/directories`),
    },
    {
      id: "5defcf7c-c008-4ea7-bfc5-4a771001e321",
      key: "dashboard/channels",
      tooltip: "Channels",
      icon: <ChannelIcon />,
      clickHandler: () => navigate(`/dashboard/channels`),
    },
    {
      id: "9d18832c-818c-4a13-a93b-8f47ec89674d",
      key: "dashboard/applications",
      tooltip: "Applications",
      icon: <MyDashBoardIcon />,
      clickHandler: () => navigate(`/dashboard/applications`),
    },
    {
      id: "4b5a6cea-df01-4777-ab2d-05bba272fb55",
      key: "dashboard/groups/list",
      tooltip: "Group List",
      icon: <GroupTypesIcon />,
      clickHandler: () => navigate(`/dashboard/groups/list`),
    },
  ];

  return (
    <>
      {/* <div className="mainside">
        <div className={sideBar ? "sidmenu active" : "sidmenu"}>
          <div className="mainsidelist">
            <ul>
              <li
                className={`${activeTab == "directory" ? "active" : ""}`}
                onClick={() => handleClick(`/dashboard/directories`)}
              >
                <MyDirectoryIcon />
                <p className="ms-3">Directories</p>
              </li>
              <li
                className={`${activeTab == "channel" ? "active" : ""}`}
                onClick={() => handleClick(`/dashboard/channels`)}
              >
                <ChannelIcon />
                <p className="ms-3"> Channels </p>
              </li>
              <li
                className={`${activeTab == "apps" ? "active" : ""}`}
                onClick={() => handleClick(`/dashboard/applications`)}
              >
                <MyDashBoardIcon />
                <p className="ms-3">Applications</p>
              </li>
              <li
                className={`${activeTab == "permission" ? "active" : ""}`}
                onClick={() => handleClick(`/dashboard/applications`)}
              >
                <PermissionsIcon />
                <p className="ms-3">Permissions</p>
              </li>
              <li
                className={`${activeTab == "roles" ? "active" : ""}`}
                onClick={() => handleClick(`/dashboard/applications`)}
              >
                <RolesIcon />
                <p className="ms-3">Roles</p>
              </li>
              <li
                className={`${activeTab == "groups" ? "active" : ""}`}
                onClick={() => handleClick(`/dashboard/applications`)}
              >
                <GroupTypesIcon />
                <p className="ms-3">Group Types</p>
              </li>
            </ul>
          </div>
          <div className="d-flex align-items-center justify-content-center flex-column">
            <p className="pwrdby">
              {" "}
              Powered by{" "}
              <strong>
                <img src={SimulanisIcon} />
                <span>Simulanis</span>
              </strong>{" "}
            </p>
          </div>
        </div>
      </div> */}

      <UISidebar mainMenuItems={[]} menuItems={menuItems} />
    </>
  );
};

export default Sidebar;
